import { Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import * as JsBarcode from 'jsbarcode';

@Component({
  selector: 'app-barcode',
  templateUrl: './barcode.component.html',
  styleUrls: ['./barcode.component.scss']
})
export class BarcodeComponent implements OnChanges {

  @Input()
  data: string | null = null;

  @Input()
  config: JsBarcode.Options | null = null;

  @ViewChild('barcode')
  barcode: ElementRef | null = null;

  constructor () { }

  montarBarcode (): void {

    if (!this.data) {
      return;
    }
    console.log(this.data);
    JsBarcode(this.barcode!.nativeElement, this.data, this.config || undefined);
  }

  ngOnChanges (changes: SimpleChanges) {

    if (changes['data']) {
      this.handleDataChange();
    }
  }

  private handleDataChange () {

    if (!this.barcode) {
      return;
    }

    this.montarBarcode();
  }

  ngAfterViewInit() {

    this.montarBarcode();
  }
}
